import type React from 'react';

interface BaseIconProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
    children: React.ReactNode;
    onClick?: React.MouseEventHandler<SVGSVGElement>;
    customeSize?: number;
}

interface IconProps {
    className?: string;
    viewBox?: string;
    onClick?: React.MouseEventHandler<SVGSVGElement>;
    strokeWidth?: number;
    customeSize?: number;
    color?: string;
}

export function BaseIconStroke({
    className = 'text-white',
    children,
    onClick,
    customeSize,
    viewBox,
    ...props
}: BaseIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={viewBox || '0 0 24 24'}
            fill="none"
            className={`${customeSize ? `w-[${customeSize}px] h-[${customeSize}px]` : 'w-6 h-6'} ${className ? ` ${className}` : ''}`}
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            role="graphics-symbol"
            onClick={onClick}
            {...props}
            style={customeSize ? { width: `${customeSize}px`, height: `${customeSize}px` } : undefined}
        >
            {children}
        </svg>
    );
}

export function BaseIconFill({
    className = 'text-white',
    viewBox = '0 0 24 24',
    children,
    onClick,
    ...props
}: BaseIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={viewBox}
            stroke="none"
            className={`w-6 h-6 ${className || ''}`}
            fill="currentColor"
            role="graphics-symbol"
            {...props}
        >
            {children}
        </svg>
    );
}

export function IconPop({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93" />
        </BaseIconStroke>
    );
}

export function IconDownload({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3" />
        </BaseIconStroke>
    );
}

export function IconNone({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M22 2L2 22M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" />
        </BaseIconStroke>
    );
}

export function IconValidate({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M7 9L10 12L20 2M19 10V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H14" />
        </BaseIconStroke>
    );
}

export function IconCheck({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M13.3334 4L6.00002 11.3333L2.66669 8" />
        </BaseIconStroke>
    );
}

export function IconCheckBox({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M10 3L4.5 8.5L2 6" />
        </BaseIconStroke>
    );
}

export function IconCheckMutiSelect({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M10 3L4.5 8.5L2 6" />
        </BaseIconStroke>
    );
}

export function IconUnpublish({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M14.5 12.5L9.5 7.5M9.5 12.5L14.5 7.5M12 17V21M12 21H8M12 21H16M4 3H20C21.1046 3 22 3.89543 22 5V15C22 16.1046 21.1046 17 20 17H4C2.89543 17 2 16.1046 2 15V5C2 3.89543 2.89543 3 4 3Z" />
        </BaseIconStroke>
    );
}

export function IconPublish({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M8 8L10 10L14 6M11 15V19M7 19H15M3 1H19C20.1046 1 21 1.89543 21 3V13C21 14.1046 20.1046 15 19 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1Z" />
        </BaseIconStroke>
    );
}

export function IconDragAndDrop({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z" />
            <path d="M9 6C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5C8 5.55228 8.44772 6 9 6Z" />
            <path d="M9 20C9.55228 20 10 19.5523 10 19C10 18.4477 9.55228 18 9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20Z" />
            <path d="M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13Z" />
            <path d="M15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6Z" />
            <path d="M15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18C14.4477 18 14 18.4477 14 19C14 19.5523 14.4477 20 15 20Z" />
        </BaseIconStroke>
    );
}

export function IconProfile({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13ZM12 13C14.1217 13 16.1566 13.8429 17.6569 15.3431C19.1571 16.8434 20 18.8783 20 21M12 13C9.87827 13 7.84344 13.8429 6.34315 15.3431C4.84285 16.8434 4 18.8783 4 21" />
        </BaseIconStroke>
    );
}

export function IconChevronDown({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M6 9L12 15L18 9" />
        </BaseIconStroke>
    );
}

export function IconChevronRight({ className, strokeWidth }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M9 18L15 12L9 6" strokeWidth={strokeWidth ? strokeWidth : undefined} />
        </BaseIconStroke>
    );
}

export function IconChevron({ className, strokeWidth = 0, color = '#DD06AE', viewBox }: IconProps) {
    return (
        <BaseIconFill className={className} viewBox={viewBox}>
            <polygon
                fill={color}
                stroke={color}
                strokeWidth={strokeWidth}
                points="12.1 0 6.4 0 14.2 12 6.4 24 12.1 24 20.7 12 12.1 0"
            />
        </BaseIconFill>
    );
}

export function IconMousePointerClick({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M16.0708 16.071L20.3138 20.314M7.18779 2.23901L7.96479 5.13601M5.13579 7.96501L2.23779 7.18801M13.9498 4.05001L11.8278 6.17201M6.17079 11.828L4.05079 13.95M9 9L14 21L15.774 15.774L21 14L9 9Z" />
        </BaseIconStroke>
    );
}

export function IconSubtitles({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M7 13H11M15 13H17M7 9H9M13 9H17M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" />
        </BaseIconStroke>
    );
}

export function IconSort({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M21,16l-4,4-4-4" />
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M17,20V4" />
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M3,8l4-4,4,4" />
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M7,4v16" />
        </BaseIconStroke>
    );
}
export function IconSortAsc({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M13,8l4-4,4,4" />
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M17,4v16" />
        </BaseIconStroke>
    );
}
export function IconSortDsc({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M21,16l-4,4-4-4" />
            <path strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M17,20V4" />
        </BaseIconStroke>
    );
}

export function IconCast({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M2 8V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H14M2 12C4.04738 12.2173 5.95837 13.1299 7.41421 14.5858C8.87006 16.0416 9.78273 17.9526 10 20M2 16C2.99265 16.1849 3.90608 16.666 4.62006 17.3799C5.33404 18.0939 5.81512 19.0073 6 20M2 20H2.01" />
        </BaseIconStroke>
    );
}

export function IconArrowUpRight({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M7 7H17M17 7V17M17 7L7 17" />
        </BaseIconStroke>
    );
}

export function IconDanger({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M12 8.99997V13M12 17H12.01M21.7299 18L13.7299 3.99998C13.5555 3.69218 13.3025 3.43617 12.9969 3.25805C12.6912 3.07993 12.3437 2.98608 11.9899 2.98608C11.6361 2.98608 11.2887 3.07993 10.983 3.25805C10.6773 3.43617 10.4244 3.69218 10.2499 3.99998L2.24993 18C2.07361 18.3053 1.98116 18.6519 1.98194 19.0045C1.98272 19.3571 2.07671 19.7032 2.25438 20.0078C2.43204 20.3124 2.68708 20.5646 2.99362 20.7388C3.30017 20.9131 3.64734 21.0032 3.99993 21H19.9999C20.3508 20.9996 20.6955 20.9069 20.9992 20.7313C21.303 20.5556 21.5551 20.3031 21.7304 19.9991C21.9057 19.6951 21.998 19.3504 21.9979 18.9995C21.9978 18.6486 21.9054 18.3039 21.7299 18Z" />
        </BaseIconStroke>
    );
}

export function IconFacebook({ className }: IconProps) {
    return (
        <BaseIconFill className={className}>
            <path d="M3.69598 11.248C3.62398 11.248 2.03998 11.248 1.31998 11.248C0.935979 11.248 0.815979 11.104 0.815979 10.744C0.815979 9.78401 0.815979 8.80001 0.815979 7.84001C0.815979 7.45601 0.959979 7.33601 1.31998 7.33601H3.69598C3.69598 7.26401 3.69598 5.87201 3.69598 5.22401C3.69598 4.26401 3.86398 3.35201 4.34398 2.51201C4.84798 1.64801 5.56798 1.07201 6.47998 0.736011C7.07998 0.520011 7.67998 0.424011 8.32798 0.424011H10.68C11.016 0.424011 11.16 0.568011 11.16 0.904011V3.64001C11.16 3.97601 11.016 4.12001 10.68 4.12001C10.032 4.12001 9.38398 4.12001 8.73598 4.14401C8.08798 4.14401 7.75198 4.45601 7.75198 5.12801C7.72798 5.84801 7.75198 6.54401 7.75198 7.28801H10.536C10.92 7.28801 11.064 7.43201 11.064 7.81601V10.72C11.064 11.104 10.944 11.224 10.536 11.224C9.67198 11.224 7.82398 11.224 7.75198 11.224V19.048C7.75198 19.456 7.63198 19.6 7.19998 19.6C6.19198 19.6 5.20798 19.6 4.19998 19.6C3.83998 19.6 3.69598 19.456 3.69598 19.096C3.69598 16.576 3.69598 11.32 3.69598 11.248Z" />
        </BaseIconFill>
    );
}

export function IconCalendar({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M14 1V5M6 1V5M1 9H19M6 13H6.01M10 13H10.01M14 13H14.01M6 17H6.01M10 17H10.01M14 17H14.01M3 3H17C18.1046 3 19 3.89543 19 5V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V5C1 3.89543 1.89543 3 3 3Z" />
        </BaseIconStroke>
    );
}

export function IconChill({ className, viewBox }: IconProps) {
    return (
        <BaseIconFill className={className} viewBox={viewBox}>
            <g clipPath="url(#clip0_1460_5130)">
                <path
                    d="M0.0551071 31.6593C0.563072 28.5123 1.66618 25.3383 3.31332 22.6011C3.95554 24.8524 5.69987 26.6428 7.92711 27.3391C7.59949 28.0414 7.31495 28.7648 7.06647 29.5012C8.16356 29.5263 9.26867 29.5223 10.3618 29.4802C12.1011 27.0746 15.74 25.7691 18.7087 28.0785C19.4481 26.4825 20.0031 24.8484 20.3007 23.1331C18.9822 23.2122 17.6647 23.3134 16.3562 23.4928C16.7369 22.6371 16.9483 21.6923 16.9483 20.6964C16.9483 19.428 16.6037 18.2408 16.0055 17.2158C18.5574 16.9132 21.1373 16.8241 23.6972 16.6147C25.4515 16.4704 26.7961 18.1586 26.8462 19.7647C26.9975 24.2071 25.712 28.346 23.7012 32.2174C25.718 33.8385 27.5946 35.2963 29.6585 36.9715C32.2865 34.3445 35.3283 32.0811 38.3631 30.0312C39.9451 28.9632 41.7937 29.5944 43.1372 30.6484C47.2551 33.8786 51.3749 37.1127 55.4928 40.3459C56.117 40.8368 56.5067 41.3849 56.7041 41.9489C57.8663 41.9489 59.0275 41.9489 60.1887 41.9489C65.2704 41.9489 65.2704 49.825 60.1887 49.825C50.2127 49.825 40.2367 49.825 30.2607 49.825C27.8801 49.825 26.4374 48.6237 25.6459 47.9414C20.1534 43.1883 16.6337 40.7998 11.1392 36.0457C11.01 35.9355 10.8968 35.8223 10.7866 35.7101C8.21867 35.8273 5.63274 35.7632 3.08789 35.6439C0.889698 35.5477 -0.275528 33.7253 0.0551071 31.6593ZM44.8775 41.9489C43.3276 40.7316 41.7756 39.5163 40.2277 38.302C38.6667 39.4101 37.1158 40.6154 35.7191 41.9489C38.7709 41.9489 41.8247 41.9489 44.8775 41.9489Z"
                    fill="url(#paint0_linear_1460_5130)"
                />
                <path
                    d="M9.82873 26.4324C6.44829 26.4324 3.70105 23.6821 3.70105 20.3027C3.70105 16.9243 6.45129 14.175 9.82873 14.175C13.2062 14.175 15.9554 16.9253 15.9554 20.3027C15.9564 23.6821 13.2062 26.4324 9.82873 26.4324Z"
                    fill="url(#paint1_linear_1460_5130)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_1460_5130"
                    x1="43.2711"
                    y1="49.825"
                    x2="2.74356"
                    y2="43.8673"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B30169" />
                    <stop offset="1" stopColor="#EA05FF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1460_5130"
                    x1="11.9864"
                    y1="26.4324"
                    x2="4.10462"
                    y2="25.8312"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B30169" />
                    <stop offset="1" stopColor="#EA05FF" />
                </linearGradient>
                <clipPath id="clip0_1460_5130">
                    <rect width="64" height="64" fill="white" transform="matrix(-1 0 0 1 64 0)" />
                </clipPath>
            </defs>
        </BaseIconFill>
    );
}

export function IconShield({ className, viewBox }: IconProps) {
    return (
        <BaseIconFill className={className} viewBox={viewBox}>
            <path
                d="M58.864 16.4735C58.7875 14.7898 58.7875 13.1827 58.7875 11.5755C58.7875 10.2744 57.7926 9.27952 56.4915 9.27952C46.925 9.27952 39.6544 6.52436 33.6084 0.63139C32.69 -0.210463 31.3124 -0.210463 30.394 0.63139C24.348 6.52436 17.0775 9.27952 7.51094 9.27952C6.20989 9.27952 5.21498 10.2744 5.21498 11.5755C5.21498 13.1827 5.21498 14.7898 5.13844 16.4735C4.83232 32.5453 4.37312 54.5865 31.2359 63.8469L32.0012 64L32.7665 63.8469C59.5528 54.5865 59.1701 32.6218 58.864 16.4735ZM30.1645 38.7444C29.7053 39.1271 29.1695 39.3566 28.5573 39.3566H28.4807C27.8685 39.3566 27.2562 39.0505 26.8736 38.5913L19.7561 30.7085L23.2 27.6472L28.7869 33.8463L41.1851 22.0604L44.3229 25.4278L30.1645 38.7444Z"
                fill="url(#paint0_linear_1464_7987)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1464_7987"
                    x1="22.514"
                    y1="64"
                    x2="57.2162"
                    y2="61.7716"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#B30169" />
                    <stop offset="1" stopColor="#EA05FF" />
                </linearGradient>
            </defs>
        </BaseIconFill>
    );
}

export function IconLinkedin({ className }: IconProps) {
    return (
        <BaseIconFill className={className}>
            <path d="M21.6 0H2.4C1.08 0 0 1.08 0 2.4V21.6C0 22.92 1.08 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V2.4C24 1.08 22.92 0 21.6 0ZM7.2 20.4H3.6V9.6H7.2V20.4ZM5.4 7.56C4.2 7.56 3.24 6.6 3.24 5.4C3.24 4.2 4.2 3.24 5.4 3.24C6.6 3.24 7.56 4.2 7.56 5.4C7.56 6.6 6.6 7.56 5.4 7.56ZM20.4 20.4H16.8V14.04C16.8 13.08 15.96 12.24 15 12.24C14.04 12.24 13.2 13.08 13.2 14.04V20.4H9.6V9.6H13.2V11.04C13.8 10.08 15.12 9.36 16.2 9.36C18.48 9.36 20.4 11.28 20.4 13.56V20.4Z" />
        </BaseIconFill>
    );
}

export function IconSearch({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M21.0002 21L16.7002 16.7M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" />
        </BaseIconStroke>
    );
}

export function IconPlus({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M5 12H19M12 5V19" />
        </BaseIconStroke>
    );
}

export function IconLess({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M5 12H19" />
        </BaseIconStroke>
    );
}

export function IconClose({ className, onClick, ...rest }: IconProps) {
    return (
        <BaseIconStroke className={className} {...rest} onClick={onClick}>
            <path d="M18 6L6 18M6 6L18 18" />
        </BaseIconStroke>
    );
}

export function IconFileWarning({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M12 9V13M12 17H12.01M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z" />
        </BaseIconStroke>
    );
}

export function IconWarningRound({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" />
        </BaseIconStroke>
    );
}
export function IconShoppingCart({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M2.0498 2.05005H4.0498L6.7098 14.47C6.80738 14.9249 7.06048 15.3315 7.42552 15.6199C7.79056 15.9083 8.24471 16.0604 8.7098 16.05H18.4898C18.945 16.0493 19.3863 15.8933 19.7408 15.6079C20.0954 15.3224 20.3419 14.9246 20.4398 14.48L22.0898 7.05005H5.1198M9 21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21C7 20.4477 7.44772 20 8 20C8.55228 20 9 20.4477 9 21ZM20 21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21C18 20.4477 18.4477 20 19 20C19.5523 20 20 20.4477 20 21Z" />
        </BaseIconStroke>
    );
}

export function IconNoPublish({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" />
        </BaseIconStroke>
    );
}

export function IconLoading() {
    return (
        <BaseIconStroke
            className="w-12 h-12 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            fill="none"
        >
            <path
                d="M24 4V12M24 36V44M9.86 9.86L15.52 15.52M32.48 32.48L38.14 38.14M4 24H12M36 24H44M9.86 38.14L15.52 32.48M32.48 15.52L38.14 9.86"
                stroke="currentColor"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </BaseIconStroke>
    );
}

export function IconFrenchFlag({ className }: IconProps) {
    return (
        <BaseIconFill className={className} strokeWidth="0">
            <g clipPath="url(#clip0_176_9487)">
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill="#F0F0F0"
                />
                <path
                    d="M24 12C24 6.84043 20.7435 2.44191 16.1739 0.746399V23.2537C20.7435 21.5581 24 17.1596 24 12Z"
                    fill="#D80027"
                />
                <path
                    d="M0 12C0 17.1596 3.25655 21.5581 7.82611 23.2536V0.746399C3.25655 2.44191 0 6.84043 0 12Z"
                    fill="#0052B4"
                />
            </g>
            <defs>
                <clipPath id="clip0_176_9487">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </BaseIconFill>
    );
}

export function IconPortugueseFlag({ className }: IconProps) {
    return (
        <BaseIconFill className={className} strokeWidth="0">
            <g clipPath="url(#clip0_176_9594)">
                <path
                    d="M0 12C0 17.1595 3.2565 21.5581 7.82602 23.2536L8.86955 12L7.82602 0.746399C3.2565 2.44196 0 6.84043 0 12Z"
                    fill="#6DA544"
                />
                <path
                    d="M24 12C24 5.37262 18.6273 0 12 0C10.5321 0 9.12602 0.264047 7.82599 0.746391V23.2536C9.12602 23.736 10.5321 24 12 24C18.6273 24 24 18.6274 24 12Z"
                    fill="#D80027"
                />
                <path
                    d="M7.82611 16.1739C10.1313 16.1739 12 14.3052 12 12C12 9.69483 10.1313 7.82611 7.82611 7.82611C5.52094 7.82611 3.65222 9.69483 3.65222 12C3.65222 14.3052 5.52094 16.1739 7.82611 16.1739Z"
                    fill="#FFDA44"
                />
                <path
                    d="M5.47827 9.91302V12.5217C5.47827 13.8184 6.5294 14.8695 7.8261 14.8695C9.1228 14.8695 10.1739 13.8184 10.1739 12.5217V9.91302H5.47827Z"
                    fill="#D80027"
                />
                <path
                    d="M7.82608 13.3043C7.39455 13.3043 7.04346 12.9532 7.04346 12.5217V11.4783H8.60866V12.5218C8.60866 12.9532 8.25757 13.3043 7.82608 13.3043Z"
                    fill="#F0F0F0"
                />
            </g>
            <defs>
                <clipPath id="clip0_176_9594">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </BaseIconFill>
    );
}

export function IconSpanishFlag({ className }: IconProps) {
    return (
        <BaseIconFill className={className} strokeWidth="0">
            <path
                d="M0 12C0 13.4679 0.264047 14.8739 0.746391 16.1739L12 17.2174L23.2536 16.1739C23.736 14.8739 24 13.4679 24 12C24 10.5322 23.736 9.12612 23.2536 7.82614L12 6.78265L0.746391 7.82614C0.264047 9.12612 0 10.5322 0 12H0Z"
                fill="#FFDA44"
            />
            <path
                d="M23.2536 7.82611C21.5581 3.25655 17.1596 0 12 0C6.84043 0 2.44191 3.25655 0.746399 7.82611H23.2536Z"
                fill="#D80027"
            />
            <path
                d="M0.746399 16.1739C2.44191 20.7435 6.84043 24 12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746399Z"
                fill="#D80027"
            />
        </BaseIconFill>
    );
}

export function IconUsaFlag({ className }: IconProps) {
    return (
        <BaseIconFill className={className} strokeWidth="0">
            <path
                d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                fill="#F0F0F0"
            />
            <path d="M11.4783 12H24C24 10.9169 23.8556 9.86768 23.5866 8.86957H11.4783V12Z" fill="#D80027" />
            <path
                d="M11.4783 5.73916H22.2387C21.5041 4.54047 20.5649 3.48095 19.4698 2.6087H11.4783V5.73916Z"
                fill="#D80027"
            />
            <path
                d="M12 24C14.8242 24 17.42 23.0239 19.4698 21.3914H4.53021C6.58006 23.0239 9.17585 24 12 24Z"
                fill="#D80027"
            />
            <path
                d="M1.76128 18.2609H22.2387C22.8285 17.2986 23.2858 16.2467 23.5866 15.1304H0.413391C0.714188 16.2467 1.17155 17.2986 1.76128 18.2609Z"
                fill="#D80027"
            />
            <path
                d="M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z"
                fill="#0052B4"
            />
        </BaseIconFill>
    );
}

export function IconTrash({ className, customeSize, viewBox }: IconProps) {
    return (
        <BaseIconStroke className={className} customeSize={customeSize || undefined} viewBox={viewBox || undefined}>
            <path d="M2.5 5.00002H17.5M15.8333 5.00002V16.6667C15.8333 17.5 15 18.3334 14.1667 18.3334H5.83333C5 18.3334 4.16667 17.5 4.16667 16.6667V5.00002M6.66667 5.00002V3.33335C6.66667 2.50002 7.5 1.66669 8.33333 1.66669H11.6667C12.5 1.66669 13.3333 2.50002 13.3333 3.33335V5.00002M8.33333 9.16669V14.1667M11.6667 9.16669V14.1667" />
        </BaseIconStroke>
    );
}

export function IconFilter({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M2 14H6M10 8H14M18 16H22" />
        </BaseIconStroke>
    );
}

export function IconSignOut({ className }: IconProps) {
    return (
        <BaseIconStroke className={className}>
            <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9" />
        </BaseIconStroke>
    );
}
